import { navigateAction } from 'fluxible-router';
import { getNetwork, setToken } from 'app/scripts/services/app-state';
import request from '@host-panel/request';
import { console } from 'utils/global';
import { LocalStorageItems } from '../../../constants';
import {
  clearSpotDataFromRedux,
  clearSpotSelectorFromRedux,
  clearSuperAdminFromRedux
} from 'state/helpers/syncHelpers';
import { dispatch } from 'state/store';
import { resetVerification } from '../../../auth/authSlice';

export default async function (context, { spotId, redirectUrl, navigateUrl }, done) {
  try {
    await request('/logout', {
      method: 'POST',
      service: 'me',
      data: {
        spot_id: spotId
      },
      addJWTtoLocalStorage: true
    });

    let network = getNetwork();
    let { token } = await request(`/network-token/${network.id}`, {
      method: 'POST',
      service: 'me',
      addJWTtoLocalStorage: true
    });
    setToken(token);

    dispatch(resetVerification());

    clearSpotDataFromRedux();
    clearSuperAdminFromRedux();
    clearSpotSelectorFromRedux();

    if (redirectUrl) {
      window.location = redirectUrl;
    }

    if (navigateUrl) {
      context.executeAction(navigateAction, { url: navigateUrl });
    }

    Object.values(LocalStorageItems).forEach(item => localStorage.removeItem(item));
    done();
  } catch (error) {
    console.error('ERROR ', error);
    context.dispatch('LOGOUT_ACCOUNT_FAILED', error);
    done();
  }
}
